import { groupBy } from "@omnia/shared/utils/array";
import { ICrop } from "../../../omnia";
import { CroppingEditVm } from "./croppingEditVm";
import { getCropCssColor } from "@omnia/shared/fields";

export class CroppingGroup {

    static createGroups(cropping: CroppingEditVm[]): CroppingGroup[] {

        var groups = groupBy(cropping, c => c.crop, c => c.CropId)
            .map(g => new CroppingGroup(g.key, g.values));

        groups = groups.sort((g1, g2) => g1.cropName.localeCompare(g2.cropName));

        return groups;
    }

    private _showApplications: boolean = true

    constructor(public crop: ICrop, public cropping: CroppingEditVm[]) {
    }

    get cropName() {
        return this.crop?.Name ?? ""
    }

    get hasSelectedItems(): boolean {
        return this.cropping.some(c => c.selected);
    }

    getCropColor() {
        return getCropCssColor(this.crop);
    }

    get showApplications() {
        return this._showApplications
    }

    set showApplications(value: boolean) {
        this._showApplications = value
        this.cropping.forEach(c => c.expanded = value)
    }
}
